import { render, staticRenderFns } from "./download_files.vue?vue&type=template&id=284cdf4f&scoped=true&"
import script from "./download_files.vue?vue&type=script&lang=js&"
export * from "./download_files.vue?vue&type=script&lang=js&"
import style0 from "./download_files.vue?vue&type=style&index=0&id=284cdf4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cdf4f",
  null
  
)

export default component.exports